/* ============================================================================
   CircleDrops — Mobile Slideshow externalized script
   ----------------------------------------------------------------------------
   Save this file as:  assets/section-slideshow-mobile.js
   Loaded from section-slideshow-mobile.liquid with:
     <script src="{{ 'section-slideshow-mobile.js' | asset_url }}" defer></script>

   The only Liquid the inline script used was getElementById('MobSlideshow-{{ sec_id }}').
   This file instead finds every [data-mob-slideshow] root on the page and
   initialises each (guarded against double-init), so NO Liquid and no config
   bridge are needed — the root already carries data-mob-slideshow / data-autoplay
   / data-autoplay-ms. Works for any number of instances on a page.

   Shopify does NOT render Liquid inside asset .js files; this file is pure JS.
   With `defer` it runs after the DOM is parsed, so every root exists before init.
   ========================================================================== */

(function () {
  'use strict';

  function initSlideshow(root) {
    if (!root || root.__mobSlideshowInit) return;
    root.__mobSlideshowInit = true;

    var track = root.querySelector('[data-track]');
    var slides = root.querySelectorAll('.mob-slide');
    if (!track || !slides.length) return;

    var dots = root.querySelectorAll('[data-dot]');
    var prevBtn = root.querySelector('[data-prev]');
    var nextBtn = root.querySelector('[data-next]');
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var autoplayMs = parseInt(root.getAttribute('data-autoplay-ms'), 10) || 4000;
    var currentIndex = 0;
    var timer = null;

    function goTo(i) {
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      currentIndex = i;
      var slide = slides[i];
      var target = slide.offsetLeft - (track.clientWidth - slide.clientWidth) / 2;
      track.scrollTo({ left: target, behavior: 'smooth' });
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentIndex - 1); resetAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIndex + 1); resetAutoplay(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        goTo(parseInt(d.getAttribute('data-dot'), 10));
        resetAutoplay();
      });
    });

    var scrollTimeout;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function () {
        var center = track.scrollLeft + track.clientWidth / 2;
        var closest = 0;
        var closestDist = Infinity;
        slides.forEach(function (s, idx) {
          var sCenter = s.offsetLeft + s.clientWidth / 2;
          var dist = Math.abs(sCenter - center);
          if (dist < closestDist) { closestDist = dist; closest = idx; }
        });
        if (closest !== currentIndex) {
          currentIndex = closest;
          dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === closest); });
        }
      }, 80);
    });

    function startAutoplay() {
      if (!autoplay || slides.length < 2) return;
      stopAutoplay();
      timer = setInterval(function () { goTo(currentIndex + 1); }, autoplayMs);
    }
    function stopAutoplay() { if (timer) { clearInterval(timer); timer = null; } }
    function resetAutoplay() { stopAutoplay(); startAutoplay(); }

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    root.addEventListener('touchstart', stopAutoplay, { passive: true });
    root.addEventListener('touchend', function () { setTimeout(startAutoplay, 2000); }, { passive: true });

    startAutoplay();
  }

  function boot() {
    document.querySelectorAll('[data-mob-slideshow]').forEach(initSlideshow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();